import Button from '@blocks/Button'
import Grid from '@blocks/Grid'
import { colors } from '@styles/vars'
import useSocialiteController from '@auth/api/useSocialiteController'
import React from 'react'
import styled from 'styled-components'
import { useAuthTemplateContext } from '../context'

export default function AuthSocial() {
    const { isSocial } = useAuthTemplateContext()
    const controller = useSocialiteController()

    const redirectTo = async (service: "google" | "facebook") => {
        const redirect = await controller.redirect(service).request()
        window.location.href = redirect
    }

    if (!isSocial) 
        return null

    return (
        <Grid>
            <Grid columns="2" gap="15px">
                <Button type="google" onClick={() => redirectTo("google")}>Google</Button>
                <Button type="facebook" onClick={() => redirectTo("facebook")}>Facebook</Button>
            </Grid>
            <Divider><span>Or</span></Divider>
        </Grid>
    )
}

const Divider = styled.div`
    display: flex;
    align-items: center;
    color: ${colors.darkGrey};
    text-transform: uppercase;

    &:after {
        margin-left: 15px;
    }

    &:before {
        margin-right: 15px;
    }

    &:after, &:before {
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background: ${colors.border};
    }
`